<!-- 申请情况 -->
<template>
  <div class="application-status">
    <div>
      <Form ref="formValidate"
            :model="formValidate"
            :rules="ruleValidate">

        <h1>申请情况</h1>
        <p>若您拿到了该项目的Offer，还请填写；您也可联系导师，让他们也分享您的喜悦</p>
        <FormItem label="申请结果"
                  prop="applyResult"
                  :label-width=240>
          <Select v-model="formValidate.applyResult"
                  placeholder="Select">
            <Option v-for="(item, index) in appResultMap"
                    :key="index"
                    :value="item.value">{{item.title}}</Option>
          </Select>
        </FormItem>
        <FormItem label="申请结果通知日期"
                  prop="resultTime"
                  :label-width=240>
          <DatePicker type="date"
                      placeholder="Select"
                      style="width: 100%"
                      v-model="formValidate.resultTime"></DatePicker>
        </FormItem>
        <FormItem label="确认入读"
                  prop="enrolment"
                  :label-width=240>
          <Select v-model="formValidate.enrolment"
                  placeholder="Select">
            <Option v-for="item in enrolmentMap"
                    :key="item[0]"
                    :value="item[0]">{{item[1]}}</Option>
          </Select>
        </FormItem>
        <div class="application-status-reason">
          <FormItem label="录取原因"
                    prop="enrollReason">
            <Input type="textarea"
                   :rows=5
                   v-model="formValidate.enrollReason"
                   placeholder="Please limit your response to 50 words"></Input>
          </FormItem>
        </div>
        <div class="application-status-btn" v-if="isallowedit">
          <Button class="zlr-btn-primary"
                  @click="handleSub"
                  :loading="isSub">提交</Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
// api
import { getProjectResult, subProjectResult } from '@/api/project'
// constant
import { appResultMap, enrolmentMap } from '@/constant'
// validator
import { validateChinese, validateWordsNum } from '@/libs/validator'

import isAllowEdit from '@/view/mixins/is-edit'
export default {
  name: 'project-application-status',
  components: {},
  mixins: [isAllowEdit],
  data () {
    return {
      appResultMap,
      enrolmentMap,
      formValidate: {},
      ruleValidate: {
        applyResult: [{ required: true, message: '请选择申请结果' }],
        resultTime: [{ required: true, message: '请选择申请结果通知日期' }],
        enrollReason: [{ required: true, message: '请填写录取原因' }, { validator: validateChinese }, { validator: validateWordsNum, wordsNum: 50 }]
      },
      programId: this.$route.params.id,
      isSub: false
    }
  },
  computed: {},
  mounted () {
    this.getProjectResult()
  },
  methods: {
    // 获取结果
    getProjectResult () {
      getProjectResult({
        id: this.programId
      }).then(res => {
        let data = res.data.model
        this.formValidate = {
          applyResult: data.applyResult,
          resultTime: data.resultTime && new Date(data.resultTime),
          enrollReason: data.enrollReason,
          enrolment: data.enrolment
        }
      })
    },
    // 提交数据
    handleSub () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          data.id = this.programId
          this.isSub = true
          subProjectResult(data).then(res => {
            this.$zlr_message('提交成功', 'success')
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          }).then(() => {
            this.isSub = false
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
